import mitt from 'mitt';
const emitter = mitt();
if (window.Cypress) {
    window.EventBus = emitter;
}
/**
 * 이벤트 바인딩
 * @param eventMapper
 */
export const addEventList = (eventMapper) => {
    Object.entries(eventMapper).forEach(([eventName, eventBody,]) => {
        emitter.on(eventName, eventBody);
    });
};
/**
 * 이벤트 해제
 * @param eventMapper
 */
export const removeEventList = (eventMapper = []) => {
    eventMapper.forEach((eventName) => {
        emitter.off(eventName);
    });
};
/**
 * 이벤트 버스에 등록된 이벤트 호출
 * @param eventName
 * @param payload
 * @returns
 */
export const emitEvent = (eventName, payload) => emitter.emit(eventName, payload);
export default emitter;
